/* eslint-disable camelcase */

import React from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import BulmaContainer from 'react-bulma-components/lib/components/container';

import { MainLayout } from '../layouts';
import { TagNav, BlogList } from '../components/Blog';
import { Pagination, FeaturedBlogPosts } from '../components/Blog/atoms';

const query = graphql`
  query {
    prismic {
      allFeaturedblogs {
        edges {
          node {
            featured_blogs_enabled
            heading
            featured_blog_1 {
              _linkType
              ... on PRISMIC_Blog {
                blog_header_image
                blog_headline
                blog_post_date
                blog_post_content
                tags {
                  tag1 {
                    ... on PRISMIC_Tag {
                      tag
                      _linkType
                      _meta {
                        uid
                      }
                    }
                  }
                }
                author {
                  ... on PRISMIC_Author {
                    author_name
                    author_image
                    _meta {
                      uid
                    }
                  }
                }
                _meta {
                  uid
                }
              }
            }
            featured_blog_2 {
              _linkType
              ... on PRISMIC_Blog {
                blog_header_image
                blog_headline
                blog_post_date
                blog_post_content
                tags {
                  tag1 {
                    ... on PRISMIC_Tag {
                      tag
                      _linkType
                      _meta {
                        uid
                      }
                    }
                  }
                }
                author {
                  ... on PRISMIC_Author {
                    author_name
                    author_image
                    _meta {
                      uid
                    }
                  }
                }
                _meta {
                  uid
                }
              }
            }
            featured_blog_3 {
              _linkType
              ... on PRISMIC_Blog {
                blog_header_image
                blog_headline
                blog_post_date
                blog_post_content
                tags {
                  tag1 {
                    ... on PRISMIC_Tag {
                      tag
                      _linkType
                      _meta {
                        uid
                      }
                    }
                  }
                }
                author {
                  ... on PRISMIC_Author {
                    author_name
                    author_image
                    _meta {
                      uid
                    }
                  }
                }
                _meta {
                  uid
                }
              }
            }
          }
        }
      }
    }
  }
`;

const RenderAuthor = ({ pageContext, queryData }) => {
  const { currentPage, numAuthorPages, uid, data } = pageContext;

  const isFirst = currentPage === 1;
  const isLast = currentPage === numAuthorPages;
  const prevPage = currentPage - 1 === 1 ? `blog/author/${uid}` : `blog/author/${uid}/${(currentPage - 1).toString()}`;
  const nextPage = `blog/author/${uid}/${(currentPage + 1).toString()}`;
  const uidHyphen = uid.replace('_', '-');
  const uidReadable = uidHyphen.replace('-', ' ').replace(/(^\w|\s\w)/g, m => m.toUpperCase());
  const canonicalTag = `https://www.digitalocean.com/blog/author/${uidHyphen}`;

  const previousButton = !isFirst && (
    <Link className="button pagination" to={prevPage} rel="prev">
      Newer Posts
    </Link>
  );

  const nextButton = !isLast && numAuthorPages > 1 && (
    <Link className="button pagination" to={nextPage} rel="prev">
      Older Posts
    </Link>
  );

  return (
    <MainLayout layout="blog">
      <Helmet>
        <title>DigitalOcean Blog Author {uidReadable}</title>
        <link rel="canonical" href={canonicalTag} />
      </Helmet>
      {FeaturedBlogPosts(queryData)}
      <div className="blog-tag-container">
        {TagNav(uid)}
        <BulmaContainer>
          {BlogList(data)}
          {Pagination(previousButton, nextButton)}
        </BulmaContainer>
      </div>
    </MainLayout>
  );
};

const Author = ({ pageContext }) => (
  <>
    <StaticQuery
      query={`${query}`}
      render={queryData => <RenderAuthor queryData={queryData} pageContext={pageContext} />}
    />
  </>
);

export default Author;

RenderAuthor.propTypes = {
  pageContext: PropTypes.object.isRequired,
  queryData: PropTypes.object.isRequired,
};

Author.propTypes = {
  pageContext: PropTypes.object.isRequired,
};
